import toolsClient from "@/api/toolsClient"

const search = async (query, limit = 24, offset = 0) => {
  const { data } = await toolsClient.get(`accounts/search/`, {
    params: { limit, offset, output: "list", search: query },
  })

  return data
}

const list = async (pageNumber = 0, pageSize = 10, sortBy = "name", sortDesc = false, search) => {
  const params = { pageNumber, pageSize, sortBy, sortDesc }
  if (search) {
    params.search = search
  }
  const { data } = await toolsClient.get(`accounts/list`, { params })

  return data
}

const get = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}`)

  return data
}

const store = async (accountData) => {
  const { data } = await toolsClient.post("accounts/", accountData)

  return data
}

const update = async (accountData) => {
  const { data } = await toolsClient.put(`accounts/${accountData.key}`, accountData)

  return data
}

const destroy = async (id) => {
  const { data } = await toolsClient.delete(`portal/accounts/${id}`)

  return data
}

const deleteOwnAccount = async (id) => {
  const { data } = await toolsClient.delete(`accounts/${id}`)

  return data
}

const add = async (accountData) => {
  const { data } = await toolsClient.post("portal/accounts/", accountData)

  return data
}

const suspend = async (id) => {
  const { data } = await toolsClient.put(`accounts/${id}/suspend`)

  return data
}

const reactivate = async (id) => {
  const { data } = await toolsClient.put(`accounts/${id}/reactivate`)

  return data
}

const getStations = async (id, limit = 1000, offset = 0, deleted = false) => {
  const { data } = await toolsClient.get(
    `accounts/${id}/stations/search?limit=${limit}&offset=${offset}&deleted=${deleted}`
  )

  return data.entities
}

const getUndeleteStation = async (id, stationKey) => {
  const { data } = await toolsClient.get(`accounts/${id}/undeleteStation/${stationKey}`)

  return data
}

const updateUndeleteStation = async (id, stationKey) => {
  const { data } = await toolsClient.put(`accounts/${id}/undeleteStation/${stationKey}`)

  return data
}

const getCtlStations = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}/ctlstations`)

  return data
}

const getAccountApplications = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}/applications`)

  return data
}

const getCustomLimits = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}/customLimits`)

  return data
}

// Bulk lookup used to avoid one request per account when rendering a list.
// Returns a map keyed by accountKey.
const getBulkCustomLimits = async (accountKeys) => {
  const { data } = await toolsClient.get(`accounts/customLimits`, { params: { accountKeys } })

  return data
}

const updateCustomLimits = async (customLimitsData) => {
  const { accountKey, ...limits } = customLimitsData
  const { data } = await toolsClient.put(`accounts/${accountKey}/customLimits`, limits)

  return data
}

// Custom limits and feature flags are separate APIs.  In particular, feature
// flag overrides must be sent in the `flags` envelope; the custom-limits
// endpoint only accepts quota values.
const getFeatureFlags = async (id) => {
  const { data } = await toolsClient.get(`accounts/${id}/featureFlags`)

  return data
}

// Bulk lookup used to avoid one request per account when rendering a list.
// Returns an array of { accountKey, flags } entries.
const getBulkFeatureFlags = async (accountKeys) => {
  const { data } = await toolsClient.get(`accounts/featureFlags`, { params: { accountKeys } })

  return data
}

const updateFeatureFlags = async (id, flags) => {
  const { data } = await toolsClient.put(`accounts/${id}/featureFlags`, { flags })

  return data
}

const getFeatureFlagDefinitions = async () => {
  const { data } = await toolsClient.get("featureFlags/definitions")

  return data
}

const createAudioAdvertisingRequest = async (id, audioAdvertisingData) => {
  const formData = new FormData()

  formData.append("formData", JSON.stringify(audioAdvertisingData.formData))
  formData.append("file", audioAdvertisingData.file)

  const { data } = await toolsClient.post(`accounts/${id}/audioadvertising/request/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return data
}

export default {
  search,
  list,
  get,
  store,
  update,
  destroy,
  deleteOwnAccount,
  add,
  suspend,
  reactivate,
  getStations,
  getUndeleteStation,
  updateUndeleteStation,
  getCtlStations,
  getAccountApplications,
  getCustomLimits,
  getBulkCustomLimits,
  updateCustomLimits,
  getFeatureFlags,
  getBulkFeatureFlags,
  updateFeatureFlags,
  getFeatureFlagDefinitions,
  createAudioAdvertisingRequest,
}
